import React, { useState } from 'react'
// import addToMailchimp from 'gatsby-plugin-mailchimp'

const Mailchimp = ({ lang }) => {
  const [message, setMessage] = useState()
  const [error, setError] = useState()
  const [form, setForm] = useState({
    email: ''
  })

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const formData = new FormData()
    formData.append('EMAIL', form.email)

    try {
      await fetch('https://carpenterandcartwright.us10.list-manage.com/subscribe/post?u=89c4c73b267a66abf52443c48&id=4ec0138683', {
        method: 'POST',
        mode: 'no-cors',
        body: formData
      })

      // Since we can't read no-cors responses, assume success
      setError(null)
      setMessage('Thanks! You’ve been added to the mailing list.')
    } catch (err) {
      console.error('Mailchimp error:', err)
      setError('Something went wrong. Please try again later.')
    }
  }


  var inputClass = 'w-full appearance-none border border-primary p-3 leading-tight text-gray-700 shadow'
  return (
    <div className='component-mailchimp bg-white bg-opacity-60 py-6 px-4 text-center'>
      {!message && !error && (
        <div className='bg-darkGrey relative'>
          <div className='z-10 mx-auto container px-4 py-6 print:hidden md:pb-10 text-offWhite'>
            <div className='prose prose-lg text-center mx-auto'>
              <h2 className='mb-4 text-bold text-4xl text-brand-blue drop-shadow-[1px_1px_0px_rgba(255,255,255,1)]'>Signup to our mailing list</h2>
              <p className='text-xl'>Get the latest news and offers from Carpenter &amp; Cartwright first</p>
            </div>
            <div className='mx-auto max-w-xl mt-6 sm:w-full'>
              <form className='flex' onSubmit={handleSubmit}>
                <div className='flex-1'>
                  <label htmlFor='email' className='sr-only'>
                    Email address
                  </label>
                  <input id='email' name='email' type='email' autoComplete='email' required className={inputClass} placeholder='Enter your email' onChange={handleChange} />
                </div>
                <button className='button button-primary' type='submit' name='subscribe' id='mc-embedded-subscribe'>
                  Subscribe
                </button>
              </form>
              <p className='mt-3 text-sm text-lightGrey'>
                We care about the protection of your data. Read our{' '}
                <a href='/privacy-policy' className='font-medium hover:text-white underline'>
                  Privacy Policy.
                </a>
              </p>
            </div>
          </div>
        </div>
      )}
      {message && (
        <div className='mx-auto max-w-xl relative z-10 border border-green-200 mb-10 container rounded-md bg-green-50 p-4'>
          <div className='flex'>
            <div className='shrink-0 text-green-400'>
              <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='h-10 w-10'>
                <path strokeLinecap='round' strokeLinejoin='round' d='M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z' />
              </svg>
            </div>
            <div className='text-left prose prose-lg ml-3'>
              <h3 className='mb-0 font-medium text-green-800'>Success</h3>
              <p className='text-green-700'>{message || 'You have successfully signed up to our mailing list'}</p>
              <button className='button bg-green-600 text-white hover:bg-green-700 border border-green-700 rounded text-sm' onClick={() => setMessage()}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      {error && (
        <div className='mx-auto max-w-xl relative z-10 border border-red-200 mb-10 container rounded-md bg-red-50 p-4'>
          <div className='flex'>
            <div className='shrink-0 text-red-400'>
              <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='h-10 w-10'>
                <path strokeLinecap='round' strokeLinejoin='round' d='M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z' />
              </svg>
            </div>
            <div className='text-left prose prose-lg ml-3'>
              <h3 className='mb-0 font-medium text-red-800'>There were an errors with your submission</h3>
              <p className='text-red-700'>{String(error) || 'Please try again'}</p>
              <button className='button bg-red-500 text-white hover:bg-red-700 border border-red-700 rounded text-sm' onClick={() => setError()}>
                Try again
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
export default React.memo(Mailchimp)
